<script lang="ts">
	import { ProductPhotoPosition } from "../../../core/schema/ProductPhotoPosition.js";
	import Content from "./Content.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { flyInOnScroll } from "../utils/flyInOnScroll";

	export let externalUrl: string | undefined = undefined;
	export let photoPosition: ProductPhotoPosition;
	export let name: string;
	export let content: string;
	export let image: string;
</script>

<a
	use:flyInOnScroll
	role={externalUrl ? "link" : "none"}
	href={externalUrl}
	target="_blank"
	class="bg-tertiary flex flex-col-reverse overflow-hidden px-5 py-7 lg:min-h-screen lg:flex-row lg:px-14 lg:py-16"
	class:lg:flex-row-reverse={photoPosition === ProductPhotoPosition.Left}
>
	<div class="relative z-10 flex flex-col justify-between px-7 py-14 lg:w-full lg:max-w-[45%] lg:px-14 lg:py-16">
		<div class="absolute inset-0 -z-10 bg-white/90 backdrop-blur-xl"></div>
		<p class="text-xl font-semibold md:text-2xl lg:text-4xl">{nbspify(name)}</p>
		<div class="lg:text-2md text-[1.125rem]">
			<Content {content} />
		</div>
	</div>

	<div
		class="relative max-w-[59.0625rem] lg:flex-1 {photoPosition === ProductPhotoPosition.Left
			? 'lg:-right-14'
			: 'lg:-left-14'}"
	>
		<StaticPicture
			{image}
			alt={name}
			width={945}
			height={512}
			imgClass="lg:h-full lg:w-full lg:max-w-[59.0625rem] object-contain lg:absolute {photoPosition ===
			ProductPhotoPosition.Left
				? 'lg:object-right'
				: 'lg:object-left'}"
		/>
	</div>
</a>
